<template>
  <div class="eq-table-panel">
    <div v-if="title || $slots.extra" class="eq-table-panel__header">
      <span v-if="title" class="eq-table-panel__title">{{ title }}</span>
      <div v-if="$slots.extra" class="eq-table-panel__extra">
        <slot name="extra" />
      </div>
    </div>
    <div class="eq-table-panel__body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablePanel',
  props: {
    title: { type: String, default: '' }
  }
}
</script>

<style lang="scss" scoped>
.eq-table-panel {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.eq-table-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
}

.eq-table-panel__title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 10px;
  &::before {
    content: '';
    width: 4px;
    height: 16px;
    background: linear-gradient(180deg, var(--fn-primary) 0%, var(--fn-accent) 100%);
    border-radius: 2px;
  }
}

.eq-table-panel__extra { display: flex; gap: 8px; }

.eq-table-panel__body {
  ::v-deep .el-table {
    border: none; border-radius: 0;
    th.el-table__cell { background: #f8fafc; color: #64748b; font-weight: 500; }
    .el-table__body tr:hover > td.el-table__cell { background: #f8fafc !important; }
    th.el-table__cell > .cell, td.el-table__cell > .cell {
      text-align: center !important;
      width: auto !important;
    }
  }
  ::v-deep .el-pagination { padding: 14px 20px; background: #fff; border-top: 1px solid #f1f5f9; text-align: right; display: flex; justify-content: flex-end; align-items: center; flex-wrap: wrap; }
}
</style>
